import { inject, Injectable } from '@angular/core';
import { SystemHealthStore } from '@shared/state';
import { QueryParameterService } from '@shared/services';

export const SYSTEM_HEALTH_SESSION_STORAGE_KEY = 'systemHealthFilters';
@Injectable({
  providedIn: 'root',
})
export class SystemHealthService {
  protected readonly queryParametersService = inject(QueryParameterService);
  private readonly systemHealthStore = inject(SystemHealthStore);

  setMachine(machine: number): void {
    this.systemHealthStore.setSelectedMachine(machine);
    void this.queryParametersService.setQueryParams({ key: SYSTEM_HEALTH_SESSION_STORAGE_KEY, queryParams: { machine } });
  }
}
